import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import HomeLanding from './pages/home-landing';
import ContactUs from './pages/contact-us';
import CollectionPoints from './pages/collection-points';
import ServicesOverview from './pages/services-overview';
import PickupScheduling from './pages/pickup-scheduling';
import AdminRoutes from './pages/admin';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public routes */}
          <Route path="/" element={<HomeLanding />} />
          <Route path="/home-landing" element={<HomeLanding />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/collection-points" element={<CollectionPoints />} />
          <Route path="/services-overview" element={<ServicesOverview />} />
          <Route path="/pickup-scheduling" element={<PickupScheduling />} />

          {/* Admin routes */}
          <Route path="/admin/*" element={<AdminRoutes />} />

          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
